import { Type } from '@ilg-totallymoney/types'

import Modal from '@ilg-totallymoney/ui/components/Modal'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

interface RepresentativeExampleModalProps {
    loanType?: Type
    onModalClose: () => void
    showModal: boolean
}

const RepresentativeExampleModal = ({
    loanType,
    showModal,
    onModalClose,
}: RepresentativeExampleModalProps) => {
    if (loanType === 'Secured') {
        return (
            <Modal
                title="Representative example and Representative APRC"
                hasHeader={false}
                hasTooltipHeader={true}
                isOpen={showModal}
                onClose={onModalClose}
                isFullScreen={true}
                hasMinHeight={false}
            >
                <Stack space="space10">
                    <Text variant="100" color="light">
                        <strong>The representative example</strong> shows you
                        the APR (annual percentage rate) you’ll pay for each
                        individual credit card or loan. This includes the
                        interest rate and any fees included. You can use this to
                        work out if the card or loan is affordable for you.
                    </Text>
                    <Text variant="100" color="light">
                        <strong>Representative APRC</strong> stands for
                        Representative Annual Percentage Rate Change. This shows
                        the cost of a secured loan over its full length or
                        lifetime, representing how different rates and charges
                        could have an effect.
                    </Text>
                    <Text variant="100" color="light">
                        <strong>APRC</strong> could help you work out the
                        overall costs of different loans, from various lenders.
                        For example, some secured loans could have an
                        introductory or promotional rate, but after a certain
                        period of time, may switch to a higher variable rate.
                    </Text>
                </Stack>
            </Modal>
        )
    }

    return (
        <Modal
            title="Representative example and Representative APR."
            hasHeader={false}
            hasTooltipHeader={true}
            isOpen={showModal}
            onClose={onModalClose}
            isFullScreen={true}
            hasMinHeight={false}
        >
            <Stack space="space10">
                <Text variant="100" color="light">
                    <strong>The representative example</strong> gives you an
                    idea of how much it could cost if you borrowed an example
                    amount. This helps you compare different products and
                    provides a guide on how much taking out credit could cost.
                    Your personal offer may be different to this, so make sure
                    you read the details of any offer a lender makes to you.
                </Text>
                <Text variant="100" color="light">
                    <strong>Your representative APR</strong> is the annualised
                    rate of interest you will be charged on any balances that
                    incur interest charges. The Representative APR refers to the
                    rate that at least 51% of those accepted for the product
                    will get.
                </Text>
            </Stack>
        </Modal>
    )
}

export default RepresentativeExampleModal
